import { useState, useEffect } from 'react';
import api from '../../services/api.js';

const TYPE_CONFIG = {
  MOTION:  { icon: '🎯', color: '#FF3B5C', label: 'Mouvement' },
  OFFLINE: { icon: '📴', color: '#F59E0B', label: 'Hors ligne' },
  SOUND:   { icon: '🔊', color: '#A855F7', label: 'Son' },
};

function formatRelative(date) {
  const diff = (Date.now() - new Date(date)) / 1000;
  if (diff < 60)   return `${Math.round(diff)}s`;
  if (diff < 3600) return `${Math.round(diff/60)}min`;
  if (diff < 86400)return `${Math.round(diff/3600)}h`;
  return new Date(date).toLocaleDateString('fr-FR');
}

export default function AlertTimeline({ deviceId, limit = 20 }) {
  const [alerts, setAlerts]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const url = deviceId
      ? `/alerts?deviceId=${deviceId}&limit=${limit}`
      : `/notifications/history?limit=${limit}`;
    api.get(url)
      .then(r => setAlerts(r.data.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [deviceId, limit]);

  if (loading) return <div style={{ padding: 16, color: 'var(--elvyra-text-muted)', fontSize: 13 }}>Chargement...</div>;
  if (!alerts.length) return <div style={{ padding: 16, color: 'var(--elvyra-text-muted)', fontSize: 13 }}>Aucune alerte</div>;

  return (
    <div style={{ position: 'relative' }}>
      {/* Ligne verticale */}
      <div style={{ position: 'absolute', left: 19, top: 0, bottom: 0, width: 2, background: 'var(--elvyra-border)' }} />

      <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {alerts.map((alert, i) => {
          const cfg = TYPE_CONFIG[alert.type] || TYPE_CONFIG.MOTION;
          return (
            <div key={alert.id} style={{ display: 'flex', gap: 12, padding: '10px 0', position: 'relative' }}>
              {/* Dot */}
              <div style={{
                width: 20, height: 20, borderRadius: '50%', flexShrink: 0,
                background: alert.isRead ? 'var(--elvyra-surface-2)' : cfg.color,
                border: `2px solid ${cfg.color}`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 10, zIndex: 1,
              }}>
                {alert.isRead ? '' : '●'}
              </div>

              {/* Content */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2 }}>
                  <span style={{ fontSize: 13 }}>{cfg.icon}</span>
                  <span style={{ fontSize: 13, fontWeight: alert.isRead ? 400 : 600, color: 'var(--elvyra-text-primary)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {alert.message}
                  </span>
                </div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  {alert.device?.name && (
                    <span style={{ fontSize: 11, color: 'var(--elvyra-text-muted)' }}>📹 {alert.device.name}</span>
                  )}
                  <span style={{ fontSize: 11, color: 'var(--elvyra-text-muted)' }}>
                    {formatRelative(alert.createdAt)}
                  </span>
                </div>
                {alert.thumbnail && (
                  <img src={alert.thumbnail} alt="capture" style={{ marginTop: 6, borderRadius: 6, maxWidth: 160, maxHeight: 90, objectFit: 'cover' }} />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
